import { ButtonUiState } from '@/components/Common/Button/ButtonUi';
import {
  CartBuyerUi,
  ProductUi,
  SellerLineUi,
  TotalTicketUi,
} from '../CartUiModel';

export type CreateEditCartUi = {
  buyer?: CartBuyerUi;
  buyerError?: string;
  cartTitle: string;
  products: ProductUi[];
  sellers: SellerLineUi[];
  total: TotalTicketUi;
  saveCartButton?: ButtonUiState;
  finishCartButton?: ButtonUiState;
};

export const initialState: CreateEditCartUi = {
  cartTitle: '',
  products: [],
  sellers: [],
  total: {
    total: '',
  },
  saveCartButton: { disabled: true },
  finishCartButton: { disabled: true },
};
